import { useEffect, useState } from "react";

import useApiUrl from "../contexts/api-url-context";

export type NotionDatabase = Array<Record<string, string>>;

export default function useNotionDatabase(databaseId: string) {
  const [data, setData] = useState<NotionDatabase | null>(null);
  const apiUrl = useApiUrl();

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(`${apiUrl}/dev/notion/${databaseId}`);
        const json = await res.json();
        setData(json);
      } catch (e) {
        console.log(e);
      }
    }

    fetchData();
  }, [databaseId, apiUrl]);

  return data;
}
